import styled from "styled-components";

import Colors from "@src/constants/Colors";

export const CustomCardWrapper = styled.div`
  top: 164px;
  padding: 8px 8px;
  background-color: ${Colors.neutralwhite_50};
`;

export const CustomSmallCardWrapper = styled.div`
  padding: 8px;
`;

export const DividerWrapper = styled.div`
  margin-top: 8px;
`;

export const LastUpdatedWrapper = styled.div`
  padding: 8px 0px;
`;

export const ValueWrapper = styled.div`
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    min-width: 69px;
    flex: 0 1 89px;
  }
`;
